<template>
  <component
    :is="tag"
    :class="[
      !vertical ? 'btn-group': 'btn-group-vertical',
      size ? `btn-group-${size}` : '',
    ]"
    :role="ariaRole"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BButtonGroup',
  props: {
    size: { type: String, default: null },
    tag: { type: String, default: 'div' },
    ariaRole: { type: String, default: 'group' },
    vertical: { type: Boolean, default: false }
  }
}
</script>
